import store from '@/store/index.js';

export default async (to, from, next) => {
  await store.dispatch('mandateListModule/fetchMandatesList');
  next();
};
